import immerHandleActions from 'redux/utils/immerHandleActions';
import {
	resetNewHeaderFooterEnabled,
	setNewHeaderFooterEnabled,
	setRemoteConfig,
	setRemoteConfigAction,
} from './actions';

const init = () => ({
	sidebar: {
		billingPaymentTrack: false,
		bulkPurchase: false,
		orderTracking: false,
		prepaidLoyalty: false,
		fiberPro: true,
		bankMuscat: false,
		aamaliPlus: true,
		btlOffer: true,
		bandWidthOnDemand: true,
		copperPlan: true,
		fiberPro2b: true,
		wfbb: true,
		voc: false,
		newDashboardEnable: true,
		enableNewHeader: true,
		isLogin2FAEnabledEbu: true,
		allowDataReportingHeader: false,
		isPwdEncryptionEnabledEbu: true,
		enableMs365: false,
		isMobilePostpaidServiceOn: false,
	},
});

const reducer = {
	[setRemoteConfig](state: any, action: setRemoteConfigAction) {
		return {
			...state,
			sidebar: {
				...state?.sidebar,
				...action.payload.sidebar,
			},
		};
	},
	[setNewHeaderFooterEnabled](state: any, action: { payload: boolean }) {
		return {
			...state,
			sidebar: { ...state.sidebar, enableNewHeader: action.payload, isNewDashboardLinkEnabled: action.payload },
		};
	},
	[resetNewHeaderFooterEnabled](state: any) {
		return { ...state, sidebar: init().sidebar };
	},
};

export default immerHandleActions(reducer, init());
